import { ApplicationState } from "app/types-store";
import { ActionDispatching } from "app/types-shared";
import { api } from "./api";
import { actionCreators as caseCreateActionCreators } from "app/area/case/create/actions";
import { api as caseCreateApi } from "app/area/case/create/api";
import { CaseDraftParameter, RunAgUiArgs } 
from "app/components/ai-chat-assistant/types";
import {
  RequestAiAssistantRun,
  FailAiAssistantRun,
  FinishAiAssistantRun,
  RequestCreateDraft,
  FinishCreateDraft,
  FailCreateDraft
} from "./action-types";
import { AiAssistantActionMiddleware } from "app/components/ai-chat-assistant/hooks/ai-assistant-action-middleware";

export const actionCreators = {
  createCaseDraft: (query: CaseDraftParameter[], caseTypeId: number): ActionDispatching<any, ApplicationState> =>
    async (dispatch) => {
      dispatch(new RequestCreateDraft());

      try {
        await dispatch(
          caseCreateActionCreators(caseCreateApi).createCase(caseTypeId, null, null, null, query)
        );
        dispatch(new FinishCreateDraft());
      } catch (error: unknown) {
        const message = error instanceof Error ? error.message : String(error);
        dispatch(new FailCreateDraft(message));
      }
    },

  abortAiAssistantRun: (): ActionDispatching<any, ApplicationState> =>
    (dispatch) => {
      dispatch(new FinishAiAssistantRun());
    },

  executeAiAssistantRun: (args: RunAgUiArgs): ActionDispatching<any, ApplicationState> =>
    async (dispatch) => {
      dispatch(new RequestAiAssistantRun());

      try {
        const middleware = new AiAssistantActionMiddleware(dispatch);
        await api.executeAiAssistantRun({
          ...args,
          middlewares: [middleware]
        });
      } catch (error: unknown) {
        const message = error instanceof Error ? error.message : String(error);
        dispatch(new FailAiAssistantRun(message));
      }
    }
};
